export { default as BankExternalQr } from './bank-external-qr';
